import { render, staticRenderFns } from "./PosReceiptUpload.vue?vue&type=template&id=4cb0b2d7&scoped=true"
import script from "./PosReceiptUpload.vue?vue&type=script&lang=js"
export * from "./PosReceiptUpload.vue?vue&type=script&lang=js"
import style0 from "./PosReceiptUpload.vue?vue&type=style&index=0&id=4cb0b2d7&prod&lang=css"
import style1 from "./PosReceiptUpload.vue?vue&type=style&index=1&id=4cb0b2d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb0b2d7",
  null
  
)

export default component.exports